import { render, staticRenderFns } from "./MyPhotos.vue?vue&type=template&id=1f7aea4a"
import script from "./MyPhotos.vue?vue&type=script&lang=js"
export * from "./MyPhotos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__css-load_97e19ffdeff983ffd98998656a7028c8/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports